import CarPoint from '../../../assets/images/carPointIcon.svg';
import moment from 'moment';
export const DutyInfo = ({ data }) => {
  return (
    <div className="flex w-full items-center justify-center gap-4 h-full flex-col p-5">
      <div className="flex flex-row w-full h-full items-center justify-between">
        <div className="flex h-full  items-center flex-row gap-2">
          <div className="size-14 flex items-center justify-center p-2 rounded-full bg-[#304564]">
            <img
              src={CarPoint}
              alt="carPoint"
              className="object-contain size-full"
            />
          </div>
          <div className="flex items-center  text-sm flex-col">
            <div>{data?.vehiclePlate}</div>
            {/* <div className="w-full text-left text-gray-500 italic">Pasif</div> */}
          </div>
        </div>
      </div>
      <div className="flex text-left flex-row gap-3 justify-between w-full text-sm">
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Sürücü</div>
          <div className="w-full">{data.userIdentity}</div>
        </div>
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Hız</div>
          <div className="w-full">{data.speed} km/s</div>
        </div>
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Tarih ve Saat</div>
          <div className="w-full">
            {moment(data.deviceTime).format('DD.MM.YYYY HH:MM')}
          </div>
        </div>
      </div>
    </div>
  );
};
